import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export const goToHome = (
  router: AppRouterInstance,
  params?: URLSearchParams
) => {
  const queryString = params?.toString()
  const url = queryString ? `/?${queryString}` : '/'

  router.push(url)
}
